<template>
    <modal
        :show="show"
        :title="title"
        @save="close"
        saveText="OK"
        @close="close"
        :hideActionsCancel="true"
        :sticky-header="true"
    >
        <v-container v-if="hotelReservationPreview">
            <h5 class="text-center text-h5 d-block mt-8 pb-0">{{ $t('Guest') }}</h5>
            <v-list class="py-0 px-4 px-sm-8">
                <v-list-item two-line class="pl-0 my-2">
                    <v-list-item-content>
                        <v-list-item-title class="mb-2">{{$t('Full name')}}</v-list-item-title>
                        <v-list-item-subtitle>
                          <span class="mr-2">{{hotelReservationPreview.firstName}} {{hotelReservationPreview.lastName}}</span>
                          <template v-if="isAdmin">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    :href="getNovaUserUrl(hotelReservationPreview.userId)"
                                    target="_blank"
                                    icon
                                    color="primary"
                                  >
                                    <v-icon>mdi-account-outline</v-icon>
                                  </v-btn>
                              </template>
                              <span>{{ $t('Nova user link') }}</span>
                            </v-tooltip>
                          </template>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item two-line class="pl-0 my-2">
                    <v-list-item-content>
                        <v-list-item-title class="mb-2">{{$t('Email')}}</v-list-item-title>
                        <v-list-item-subtitle>{{hotelReservationPreview.email}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item two-line class="pl-0 my-2">
                    <v-list-item-content>
                        <v-list-item-title class="mb-2">{{$t('Phone number')}}</v-list-item-title>
                        <v-list-item-subtitle>{{hotelReservationPreview.phone}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <div class="py-0 px-4 px-sm-8 mt-8">
                <h5 class="text-center text-h5 d-block mb-6 pb-0">{{ $t('Booking details') }}</h5>
                <hotel-reservation-event-details :event="hotelReservationPreview"></hotel-reservation-event-details>
            </div>

            <div class="py-0 px-4 px-sm-8 mt-8">
                <h5 class="text-center text-h5 d-block mb-6 pb-0">{{ $t('Form Pricing Price Title') }}</h5>
                <hotel-reservation-pricing-table :reservation="hotelReservationPreview"></hotel-reservation-pricing-table>
            </div>
        </v-container>
    </modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import HotelReservationEventDetails from '@/components/reservations/HotelReservationEventDetails.vue';
import HotelReservationPricingTable from '@/components/reservations/HotelReservationPricingTable.vue';
import ApartmentMixin from '@/lib/ApartmentMixin';
import { mapGetters } from 'vuex';

export default {
  mixins: [ApartmentMixin],
  components: {
    Modal,
    HotelReservationEventDetails,
    HotelReservationPricingTable,
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    hotelReservationPreview(reservation) {
      if (reservation && reservation.id) {
        this.show = true;
      }
    },
  },
  computed: {
    ...mapGetters(['hotelReservationPreview', 'isAdmin']),
    title() {
      if (this.hotelReservationPreview && this.hotelReservationPreview.booking_reference) {
        return `${this.$t('Hotel Reservation')} (${this.hotelReservationPreview.booking_reference})`;
      }
      return this.$t('Hotel Reservation');
    },
  },
  methods: {
    close() {
      this.show = false;
      this.$store.dispatch('clearHotelReservationPreview');
    },
  },
};
</script>
